export default __webpack_public_path__ + "static/media/Valid.5eea77ae.svg";